import { ForbearanceWorkoutPlan as GqlForbearanceWorkoutPlan } from '@willow/graphql-iso/src/app';
import { ForbearanceWorkoutPlan, parseGqlIsoDate } from '@willow/types-iso';

import { getNumMonthsBetweenDates } from '../utils/dates';

/**
 * Checks whether the plan has been extended or terminated early and returns the current term months
 */
export const gqlGetCurrentForbearanceTermMonths = (workoutPlan: GqlForbearanceWorkoutPlan): number =>
  getCurrentForbearanceTermMonths({
    ...workoutPlan,
    startDate: parseGqlIsoDate(workoutPlan.startDate),
    terminationDate: workoutPlan.terminationDate ? parseGqlIsoDate(workoutPlan.terminationDate) : undefined,
  });

type GqlResolvedForbearanceWorkoutPlan = Omit<GqlForbearanceWorkoutPlan, 'startDate' | 'terminationDate'> &
  Pick<ForbearanceWorkoutPlan, 'startDate' | 'terminationDate'>;

export function getCurrentForbearanceTermMonths(workoutPlan: ForbearanceWorkoutPlan): number;
export function getCurrentForbearanceTermMonths(workoutPlan: GqlResolvedForbearanceWorkoutPlan): number;
export function getCurrentForbearanceTermMonths(
  workoutPlan: ForbearanceWorkoutPlan | GqlResolvedForbearanceWorkoutPlan,
): number {
  const { extensions, terminationDate } = workoutPlan;
  if (terminationDate) {
    return Math.round(getNumMonthsBetweenDates(workoutPlan.startDate, terminationDate));
  }

  return extensions.length > 0 ? extensions[extensions.length - 1].extensionTermMonths : workoutPlan.originalTermMonths;
}
